import React, {forwardRef} from 'react';
import { AppBar, Toolbar, Button, Box, Link as MuiLink } from '@mui/material';
import logo from '../assets/images/logo.png';
import { Link, useNavigate } from 'react-router-dom';
import PersonIcon from '@mui/icons-material/Person';
import SearchIcon from '@mui/icons-material/Search';
import BotaoNavHeader from './header/botaoNavHeader';
import { useTranslation } from 'react-i18next';
import LanguageSwitcher from './languageSwitcher';

const Header = forwardRef((props, ref) => {

    const { t } = useTranslation();
    const { setActualLocation, actualLocation } = props; 
    const navigate = useNavigate();

    const customNavigate = (rota) => {
        if (rota === '/servicos') {
            if (actualLocation === "/geradores" | actualLocation === "/servicos") {
                window.scrollTo({
                    top: window.innerHeight * 2,
                    behavior: 'smooth'
                });
            } else {
                // Hardcoded para ser mais simples
                navigate("geradores");
                setTimeout(() => {
                  window.scrollTo({
                      top: window.innerHeight * 2,
                      behavior: 'smooth'
                  })  
                }, 1000)
            }
        } else {
            navigate(rota);
        }
        setActualLocation(rota);
    }

    return (
        // position sticky
        <AppBar ref={ref} position='relative' color="none" elevation='0' sx={{height: {md: '20vh', xs: "18vh"}, }}  >
            <Toolbar disableGutters={true} sx={{padding: 0, color: '#fff'}} >
                <Box sx={{ flexGrow: 1 }}>
                    <Box sx={{ 
                        marginTop: {'lg': '25px', 'xs': '8px' },
                        marginLeft: {'lg':'45px', 'xs': '10px' },

                        }}>
                        <Link
                            to={'/'}
                            style={{ textDecoration: 'none' }}
                            onClick={() => customNavigate('/')}
                        >
                            <img src={ logo } alt="Logo" style={{ width: '100%', height: 'auto', maxWidth: '150px' }} />    
                        </Link>
                        
                    </Box>
                </Box>
                <Box sx={{ flexGrow:4, display: 'flex', alignItems: 'center', 'justifyContent': 'center' }}>
                    <nav>

                        <BotaoNavHeader navigate={customNavigate} rota={'/'} texto={t('Home')}/>
                        <BotaoNavHeader navigate={customNavigate} rota={'/geradores'} texto={t('Geradores')}/>
                        <BotaoNavHeader navigate={customNavigate} rota={'/servicos'} texto={t('Serviços')}/>
                        <BotaoNavHeader navigate={customNavigate} rota={'/cobertura'} texto={t('Rede autorizada')}/>
                        <BotaoNavHeader navigate={customNavigate} rota={'/contato'} texto={t('Contato')}/>
                        <BotaoNavHeader navigate={customNavigate} rota={'/quem-somos'} texto={t('Quem somos')}/>
                          
                    </nav>
                </Box>

                <Box sx={{ 
                    flexGrow: 1, 
                    display: 'flex', 
                    justifyContent: 'flex-end',
                }}>
                    
                    <Button
                        sx={{
                            width: '32px', 
                            minWidth: '32px',
                        }}
                        aria-label={t('Buscar no catálogo')}
                     onClick={()=>navigate('/geradores')} color="inherit"><SearchIcon/></Button>
                    {/* <Button  */}
                    <MuiLink
                        sx={{
                            display: "inherit",
                            textAlign: 'center',
                            padding: "6px 8px",
                            marginRight: {
                                lg: '15px',
                                md: "12px",
                                xs: "10px",
                            },
                            width: '32px', 
                            minWidth: '32px',
                        }}
                        aria-label={t('Área Restrita')}
                        href={'https://gmgdobrasil.com.br/admin/login.php'} color="inherit"><PersonIcon/>
                    </MuiLink>
                    {/* </Button> */}
                    <LanguageSwitcher />
                
                </Box>


            </Toolbar>
        </AppBar>
    );
});

export default Header;


      

    